var _style, _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 43,
    className: "st1",
    width: 8,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 27,
    className: "st0",
    width: 2,
    height: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 53,
    className: "st0",
    width: 2,
    height: 5.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,35v8h8v-8H41z M47,41h-4v-4h4V41z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    className: "st0",
    width: 2,
    height: 13.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 27,
    className: "st0",
    width: 2,
    height: 5.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61,35v8h8v-8H61z M67,41h-4v-4h4V41z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 45,
    className: "st0",
    width: 2,
    height: 13.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 27,
    className: "st0",
    width: 2,
    height: 5.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupDefault);
export default __webpack_public_path__ + "static/media/setup-default.9da81a08368399cf079d5fb5befab0e2.svg";
export { ForwardRef as ReactComponent };